import React, { useRef, useState, useEffect, useCallback } from "react";
import MedicalCanvassing from "../../pages/MedicalCanvassing/MedicalCanvassing";
import RecordsRequest from "../../pages/RecordsRequest/RecordsRequest";
import SocialCanvassing from "../../pages/SocialCanvassing/SocialCanvassing";
import RequestorInformationForm from "../../pages/RequestorInformationForm/RequestorInformationForm";
import ClaimantForm from "../../pages/ClaimantForm/ClaimantForm";
import OrderReview from "../../pages/OrderReview/OrderReview";
import FormNavigation from "../FormNavigation/FormNavigation";
import axios from "axios";
import { Box } from "@mui/material";
import Cookies from "js-cookie";
import FormStepper from "../FormStepper/FormStepper";

export default function Steps({ steps, activeStep, setActiveStep, showModal }) {
  const [uploadedFiles, setUploadedFiles] = useState(null);

  const [selectedMedicalCanvassOptions, setSelectedMedicalCanvassOptions] = useState([]);

  const [selectedRecordsRequestOption, setSelectedRecordsRequestOption] =
    useState(null);

  const handleCheckboxdRecordsRequestChange = (option) => {
    setSelectedRecordsRequestOption(selectedRecordsRequestOption?.id == option?.id ? null : option);
  };

  const [selectedSocialCanvassOption, setSelectedSocialCanvassOption] =
    useState(null);

  const onSocialCanvassCheckboxChange = (option) => {
    setSelectedSocialCanvassOption(selectedSocialCanvassOption?.id == option?.id ? null : option);
  };

  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);

  const [formData, setFormData] = useState({
    medicalCanvassing: {
      other: "",
    },
    requestorInformation: {
      name: "",
      company: "",
      email: "",
      title: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      phoneNumber: "",
      claimNumber: "",
      insuredClient: "",
      billToPhone: "",
      billToEmail: "",
      other: "",
    },
    claimantInformation: {
      ClaimantFirstName: "",
      ClaimantLastName: "",
      Alias: "",
      SSN: "",
      DateBirth: "",
      ClaimantAddress: "",
      city: "",
      state: "",
      zip: "",
      ClaimantEmail: "",
      Phone: "",
      EmployerName: "",
      EmployerAddress: "",
      EmployerCity: "",
      EmployerState: "",
      EmployerZip: "",
      EmployerPhone: "",
      EmployerContactName: "",
      ClaimantPosition: "",
      DateIncident: "",
      LastWorked: "",
      Nature: "",
      AdditionalComments: "",
      CoverageType: "",
      DueDate: "",
    },
  });

  const formRef = useRef(null);
  const claimantRef = useRef(null);

  const [selectedLocations, setSelectedLocations] = useState([
    { id: 1, title: "Hospital", isSelected: false, disabled: false },
    { id: 2, title: "Pharmacy", isSelected: false, disabled: false },
    { id: 3, title: "X-Ray / MRI", isSelected: false, disabled: false },
    { id: 4, title: "Doctor", isSelected: false, disabled: false },
    { id: 5, title: "Chiropractic", isSelected: false, disabled: false },
    {
      id: 6,
      title: "Health Clinic (Urgent Care)",
      isSelected: false,
      disabled: false,
    },
    { id: 7, title: "Mail Order Pharmacy", isSelected: false, disabled: false },
    { id: 8, title: "Dental", isSelected: false, disabled: false },
    { id: 9, title: "Orthopedic", isSelected: false, disabled: false },
    { id: 10, title: "Neurology", isSelected: false, disabled: false },
    {
      id: 11,
      title: "Optometry / Ophthalmology",
      isSelected: false,
      disabled: false,
    },
    { id: 12, title: "Cardiology", isSelected: false, disabled: false },
    { id: 13, title: "Podiatry", isSelected: false, disabled: false },
    { id: 14, title: "Physical Therapy", isSelected: false, disabled: false },
    {
      id: 15,
      title: "Clinical Laboratories",
      isSelected: false,
      disabled: false,
    },
    { id: 16, title: "Pain Management", isSelected: false, disabled: false },
    { id: 17, title: "Ear, Nose, Throat", isSelected: false, disabled: false },
    { id: 18, title: "Gym", isSelected: false, disabled: false },
    { id: 19, title: "Psychology", isSelected: false, disabled: false },
    { id: 20, title: "Psychiatric", isSelected: false, disabled: false },
    {
      id: 21,
      title: "Other (Explain Below)",
      isSelected: false,
      disabled: false,
    },
  ]);

  const handleCanvassByLocationTypeChange = (option) => {
    // Check if there is at least one location selected and the selected Medical Canvass Options contains the first and the second options
    if (
      selectedLocations.some((loc) => loc.isSelected) &&
      selectedMedicalCanvassOptions.some((opt) => opt.id === 0) &&
      selectedMedicalCanvassOptions.some((opt) => opt.id === 1)
    ) {
      setSelectedMedicalCanvassOptions((prevState) =>
        prevState.filter((item) => item.id === 0)
      );

      selectedLocations.forEach((loc) => {
        loc.isSelected = false;
      });
    }

    // Check if there is at least one location selected and the selected Medical Canvass Options contains the first option
    else if (
      selectedLocations.some((loc) => loc.isSelected) &&
      selectedMedicalCanvassOptions.some((opt) => opt.id === 1)
    ) {
      setSelectedMedicalCanvassOptions((prevState) =>
        prevState.filter((item) => item.id !== 1 && item.id !== 2)
      );

      selectedLocations.forEach((loc) => {
        loc.isSelected = false;
      });
    } 
    
    // Any other case
    else {
      setSelectedMedicalCanvassOptions((prevState) =>
        prevState.some((item) => item.id === option.id)
          ? prevState.filter((item) => item.id !== option.id && item.id !== 2)
          : [...prevState.filter((opt) => opt.id !== 2), option]
      );
    }
  }

  const onMedicalCanvassCheckboxChange = (option) => {
		// If the changed option is 'QuickTel Express Canvass'
		if (option?.id === 0) {
			setSelectedMedicalCanvassOptions((prevState) =>
				prevState.some((item) => item.id === option.id)
					? prevState.filter((item) => item.id !== option.id && item.id !== 2)
					: [...prevState.filter((opt) => opt.id !== 2), option]
			);
		}

		// If the changed option is 'Canvass by Location Type'
		else if (option?.id === 1) {
			handleCanvassByLocationTypeChange(option)
		}

		// If the changed option is 'I Do NOT Want a Medical Canvass Completed'
		else if (option?.id === 2) {
			// Check if the selected option is 'I Do NOT Want a Medical Canvass Completed' to remove it from the selected Medical Canvass Options
			if (selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
				setSelectedMedicalCanvassOptions((prevState) =>
					prevState.filter((item) => item.id !== 2)
				);
			}

			// Make 'I Do NOT Want a Medical Canvass Completed' is the only selected option
			else {
				setSelectedMedicalCanvassOptions([option]);
			}
		}
	};

  // Compare addresses
  const requestorAddress = {
    address: formData.requestorInformation.address?.toLowerCase().replaceAll(" ", ""),
    city: formData.requestorInformation.city?.toLowerCase().replaceAll(" ", ""),
    state: formData.requestorInformation.state?.toLowerCase().replaceAll(" ", ""),
    zip: formData.requestorInformation.zip?.toLowerCase().replaceAll(" ", ""),
  }
  const claimantAddress = {
    address: formData.claimantInformation.ClaimantAddress?.toLowerCase().replaceAll(" ", ""),
    city: formData.claimantInformation.city?.toLowerCase().replaceAll(" ", ""),
    state: formData.claimantInformation.state?.toLowerCase().replaceAll(" ", ""),
    zip: formData.claimantInformation.zip?.toLowerCase().replaceAll(" ", ""),
  }
  const isAddressInvalid = (requestorAddress.address !== "" && claimantAddress.address !== "") && JSON.stringify(requestorAddress) === JSON.stringify(claimantAddress)

  const [isMedicalCanvassingOk, setIsMedicalCanvassingOk] = useState(true);
  const handleSelectedLocations = (id, disabled) => {
    setSelectedLocations((prevLocations) =>
      prevLocations.map((location) =>
        location.id === id
          ? {
              ...location,
              isSelected: !location.isSelected,
              disabled: disabled,
            }
          : location
      )
    );
  };

  useEffect(() => {
    if (selectedMedicalCanvassOptions.some((opt) => opt.id === 0)) {
      selectedLocations[0].isSelected = false;
      selectedLocations[0].disabled = true;
      selectedLocations[1].isSelected = false;
      selectedLocations[1].disabled = true;
      setSelectedLocations(selectedLocations)
    } else {
      selectedLocations[0].disabled = false;
      selectedLocations[1].disabled = false;
      setSelectedLocations(selectedLocations)
    }

    if ((selectedMedicalCanvassOptions.some((opt) => opt.id === 2))) {
      selectedLocations.forEach(loc => {
        loc.isSelected = false
      })
    }
  }, [selectedMedicalCanvassOptions])
  
  const [receivedOrderViewModel, setReceivedOrderViewModel] = useState(null);

  const handleOrderViewModel = useCallback((orderViewModel) => {
    setReceivedOrderViewModel(orderViewModel);
  }, []);

  const saveFormDataToCookies = (data) => {
    const fieldsToSave = [
      "name",
      "company",
      "email",
      "title",
      "address",
      "city",
      "state",
      "zip",
      "phoneNumber",
    ];
    fieldsToSave.forEach((field) => {
      if (data[field]) {
        Cookies.set(field, data[field], { expires: 90 });
      }
    });
  };

  const [successSteps, setSuccessSteps] = useState([])

  const updateSuccessSteps = (step, addStep = true) => {
    if (addStep) {
      !successSteps.includes(step) && setSuccessSteps(prevState => [...prevState, step])
    } else {
      setSuccessSteps(prevState => [...prevState.filter(el => el !== step)])
    }
  }

  const handleNext = async () => {
    let canProceed = false;

    if (activeStep === 0) {
      if (isMedicalCanvassingOk) {
        canProceed = true;
        updateSuccessSteps(0)
      } else {
        canProceed = false;
        updateSuccessSteps(0, false)
      };
    } else if (activeStep === 1) {
      if (
        (selectedRecordsRequestOption?.id === 3 &&
          uploadedFiles?.recordsRequest !== null) ||
        selectedRecordsRequestOption?.id === 4
      ) {
        canProceed = true;
        updateSuccessSteps(1)
      } else {
        canProceed = false;
        updateSuccessSteps(1, false)
      };
    } else if (activeStep === 2) {
      if (selectedSocialCanvassOption !== null) {
        canProceed = true;
        updateSuccessSteps(2)
      } else {
        canProceed = false;
        updateSuccessSteps(2, false)
      };
    } else if (activeStep === 3) {
      if (formRef.current && formRef.current.handleSubmit) {
        const isValid = formRef.current.handleSubmit();
        if (isValid) {
          saveFormDataToCookies(formData.requestorInformation)
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          updateSuccessSteps(3);
        } else{
          updateSuccessSteps(3, false);
        }
        setIsReqFormValid(isValid)        
      }
    } else if (activeStep === 4) {
      if (claimantRef.current && claimantRef.current.handleSubmit) {
        const isValid = claimantRef.current.handleSubmit();
        if (isValid) {
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          updateSuccessSteps(4);
        } else {
          updateSuccessSteps(4, false);
        }
        setIsClmFormValid(isValid)       
      }
    }
    
    if (canProceed) {
      setShowError(false);
      setErrorMessage("");
      if (selectedMedicalCanvassOptions.some((opt) => opt.id === 2) && activeStep === 0) {
        setSelectedRecordsRequestOption({
          id: 4,
          title: "I Do NOT Want to Request Records Retrieval",
          description: "",
          features: [],
          header: "",
          locations: [],
        });
        setActiveStep(2);
        updateSuccessSteps(1)
      } else setActiveStep((prevActiveStep) => prevActiveStep + 1);
    } else if (
      activeStep !== 4 &&
      activeStep !== 3 &&
      activeStep !== 5 &&
      ((!selectedMedicalCanvassOptions.length && activeStep === 0) ||
        (selectedRecordsRequestOption == null && activeStep === 1) ||
        (selectedSocialCanvassOption == null && activeStep === 2))
    ) {
      setShowError(true);
      setErrorMessage("Choose one of the options above to proceed.");
    } else if (activeStep === steps.length - 1) {
      await saveOrderToBackend(receivedOrderViewModel);
    }
  };

  const [isPendingRequest, setIsPendingRequest] = useState(false);
  const saveOrderToBackend = async (orderViewModel) => {
    setIsPendingRequest(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/Orders`,
        orderViewModel,
        {}
      );
      showModal();
      return response;
    } catch (error) {
      showModal(error?.response?.data ?? "An unexpected error occurred!");
    } finally {
      setIsPendingRequest(false);
    }
  };

  const [isReqFormValid, setIsReqFormValid] = useState(false);
  const [isClmFormValid, setIsClmFormValid] = useState(false);

  useEffect(() => {
    if (activeStep === 3 && formRef.current && formRef.current.getFormStatus) {
      const isValid = formRef.current.getFormStatus();
      setIsReqFormValid(isValid)
    } else if (activeStep === 4 && claimantRef.current && claimantRef.current.getFormStatus) {
      const isValid = claimantRef.current.getFormStatus();
      setIsClmFormValid(isValid)
    }
  }, [activeStep, formData])

  const handleTabsSwitch = () => {
    let nextSuccessSteps = []

    if (isMedicalCanvassingOk) {
      updateSuccessSteps(0)
      nextSuccessSteps.push(0)

      if (selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
        setSelectedRecordsRequestOption({
          id: 4,
          title: "I Do NOT Want to Request Records Retrieval",
          description: "",
          features: [],
          header: "",
          locations: [],
        });
        updateSuccessSteps(1)
        nextSuccessSteps.push(1)
      }
    } else {
      updateSuccessSteps(0, false)
      nextSuccessSteps.filter(el => el !== 0)
    }
    
    if (
      (selectedRecordsRequestOption?.id === 3 &&
        uploadedFiles?.recordsRequest !== null) ||
      selectedRecordsRequestOption?.id === 4
    ) {
        updateSuccessSteps(1);
        nextSuccessSteps.push(1)
    } else {
      updateSuccessSteps(1, false);
      nextSuccessSteps.filter(el => el !== 1)
    }
  
    if (selectedSocialCanvassOption !== null) {
      updateSuccessSteps(2);
      nextSuccessSteps.push(2)
    } else {
      updateSuccessSteps(2, false);
      nextSuccessSteps.filter(el => el !== 2)
    };
    
    if (activeStep === 3 && formRef.current && formRef.current.handleSubmit) {
      const isValid = formRef.current.handleSubmit();
      if (isValid) {
        saveFormDataToCookies(formData.requestorInformation);
        updateSuccessSteps(3);
      } else {
        updateSuccessSteps(3, false);
      }
      setIsReqFormValid(isValid)
    } 
    
    if (activeStep === 4 && claimantRef.current && claimantRef.current.handleSubmit) {
        const isValid = claimantRef.current.handleSubmit();
        if (isValid) {
          updateSuccessSteps(4)
        } else {
          updateSuccessSteps(4, false)
        }
        setIsClmFormValid(isValid);
      }

    if (
      activeStep !== 3 &&
      activeStep !== 4 &&
      activeStep !== 5 &&
      ((!selectedMedicalCanvassOptions.length && activeStep === 0) ||
        (selectedRecordsRequestOption == null && activeStep === 1) ||
        (selectedSocialCanvassOption == null && activeStep === 2))
    ) {
      setShowError(true);
      setErrorMessage("Choose one of the options above to proceed.");
    }

    if (isReqFormValid) {
      updateSuccessSteps(3)
      nextSuccessSteps.push(3)
    } else {
      nextSuccessSteps.filter(el => el !== 3)
    }
  
    if (isClmFormValid) {
        nextSuccessSteps.push(4)
    } else {
      nextSuccessSteps.filter(el => el !== 4)
    }

    return nextSuccessSteps
  };

  const handleBack = () => {    
    let backSuccessSteps = []

    if (activeStep === 1) {
      if (
        (selectedRecordsRequestOption?.id === 3 &&
          uploadedFiles?.recordsRequest !== null) ||
        selectedRecordsRequestOption?.id === 4
      ) {
        updateSuccessSteps(1)
        backSuccessSteps.push(1)
      } else {
        updateSuccessSteps(1, false)
        backSuccessSteps.filter(el => el !== 1)
      }
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else if (activeStep === 2) {
      if (selectedSocialCanvassOption !== null && selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
        setActiveStep(0)
        updateSuccessSteps(2)
        backSuccessSteps.push(2)
      } else if (selectedSocialCanvassOption !== null && !selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        updateSuccessSteps(2);
        backSuccessSteps.push(2)
      } else if (selectedSocialCanvassOption === null && selectedMedicalCanvassOptions.some((opt) => opt.id === 2)) {
        setActiveStep(0);
        updateSuccessSteps(2, false);
        backSuccessSteps.filter(el => el !== 2)
      } else {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        updateSuccessSteps(2, false);
        backSuccessSteps.filter(el => el !== 2)
      };
    } else if (activeStep === 3 && formRef.current && formRef.current.getFormStatus) {
      const isValid = formRef.current.getFormStatus();
      if (isValid) {
        updateSuccessSteps(3);
        backSuccessSteps.push(3)
      } else {
        updateSuccessSteps(3, false);
        backSuccessSteps.filter(el => el !== 3)
      }
      setIsReqFormValid(isValid)
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else if (activeStep === 4 && claimantRef.current && claimantRef.current.getFormStatus) {
      const isValid = claimantRef.current.getFormStatus();
      if (isValid) {
        updateSuccessSteps(4);
        backSuccessSteps.push(4)
      } else {
        updateSuccessSteps(4, false);
        backSuccessSteps.filter(el => el !== 4)
      }
      setIsClmFormValid(isValid)
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    } else if (activeStep === 5) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }

    return backSuccessSteps
  };

  useEffect(() => {
    if (
      (activeStep === 0 && isMedicalCanvassingOk) ||
      (activeStep === 1 &&
        selectedRecordsRequestOption?.id === 3 &&
        uploadedFiles?.recordsRequest !== null) ||
      (activeStep === 1 && selectedRecordsRequestOption?.id === 4) ||
      (activeStep === 2 && selectedSocialCanvassOption !== null) ||
      (selectedMedicalCanvassOptions && activeStep === 0) ||
      (selectedRecordsRequestOption !== null && activeStep === 1) ||
      (selectedSocialCanvassOption !== null && activeStep === 2)
    ) {
      setShowError(false);
      setErrorMessage("");
    }
  }, [
    activeStep,
    selectedMedicalCanvassOptions,
    selectedLocations,
    selectedRecordsRequestOption,
    selectedSocialCanvassOption,
    isMedicalCanvassingOk,
    uploadedFiles,
  ]);

  return (
    <>
      <FormStepper
        steps={steps}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
        handleTabsSwitch={handleTabsSwitch}
        handleBack={handleBack}
        successSteps={successSteps}
        isMedicalCanvassDoNot={selectedMedicalCanvassOptions.some((opt) => opt.id === 2)}
      />
      <Box sx={{ flexDirection: "row", pt: 5 }}>
        {activeStep === 0 ? (
          <MedicalCanvassing
            selectedMedicalCanvassOptions={selectedMedicalCanvassOptions}
            setSelectedMedicalCanvassOptions={setSelectedMedicalCanvassOptions}
            onMedicalCanvassCheckboxChange={onMedicalCanvassCheckboxChange}
            updateLocations={handleSelectedLocations}
            selectedLocations={selectedLocations}
            onUploadFile={setUploadedFiles}
            uploadedFiles={uploadedFiles}
            setIsMedicalCanvassingOk={setIsMedicalCanvassingOk}
            formData={formData.medicalCanvassing}
            setFormData={setFormData}
          />
        ) : activeStep === 1 ? (
          <RecordsRequest
            selectedRecordsRequestOption={selectedRecordsRequestOption}
            handleCheckboxdRecordsRequestChange={
              handleCheckboxdRecordsRequestChange
            }
            onUploadFile={setUploadedFiles}
            uploadedFiles={uploadedFiles}
          />
        ) : activeStep === 2 ? (
          <SocialCanvassing
            selectedSocialCanvassOption={selectedSocialCanvassOption}
            onSocialCanvassCheckboxChange={onSocialCanvassCheckboxChange}
          />
        ) : activeStep === 3 ? (
          <RequestorInformationForm
            formData={formData.requestorInformation}
            isAddressInvalid={isAddressInvalid}
            setFormData={setFormData}
            ref={formRef}
          />
        ) : activeStep === 4 ? (
          <ClaimantForm
            formData={formData.claimantInformation}
            isAddressInvalid={isAddressInvalid}
            setFormData={setFormData}
            ref={claimantRef}
            onUploadFile={setUploadedFiles}
            uploadedFiles={uploadedFiles}
          />
        ) : (
          <div>
            <OrderReview
              formData={formData}
              selectedMedicalCanvassOptions={selectedMedicalCanvassOptions}
              selectedRecordsRequestOption={selectedRecordsRequestOption}
              selectedSocialCanvassOption={selectedSocialCanvassOption}
              uploadedFiles={uploadedFiles}
              selectedLocations={selectedLocations}
              onOrderViewModel={handleOrderViewModel}
            />
          </div>
        )}
      </Box>

      <FormNavigation
        steps={steps}
        activeStep={activeStep}
        handleNext={handleNext}
        handleBack={handleBack}
        showError={showError}
        errorMessage={errorMessage}
        isPendingRequest={isPendingRequest}
      />
    </>
  );
}
